// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"a03a9725","213":"9f855817","239":"0cf264bf"}[chunkId] + ".chunk.js";
};